import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Platform, View } from 'react-native'

import styled from 'styled-components/native'

import { parseTimeLeft } from './formatter'

import { Text } from '../../../Atoms/Typography'
import Icon from '../../../Atoms/Icon'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  background-color: ${props => props.black ? theme.colours.black : theme.colours.white};
  width: ${Platform.OS === 'web' ? 210 : 160}px;
  height: ${theme.headerHeight}px;
`

class Clock extends PureComponent {
  constructor (props) {
    super()
    const { time, displayType } = parseTimeLeft(props.finishTime)
    this.state = {
      time: time,
      displayType: displayType
    }
  }

  componentDidMount () {
    this.timer = setInterval(this.updateTimer, 1000)
  }

  componentWillUnmount () {
    clearInterval(this.timer)
  }

  updateTimer = () => {
    const { time, displayType } = parseTimeLeft(this.props.finishTime)
    this.setState({
      time: time,
      displayType: displayType
    })
  }

  render () {
    const isBlack = !!this.props.black
    return (
      <Container black={isBlack}>
        <Icon size='huge' name='clock' darkgrey={!isBlack} white={isBlack} />
        {this.state.displayType === 'D' ? (
          <Text
            size='xxs' darkgrey={!isBlack} white={isBlack}
            overrides={{ marginLeft: 0.5 * theme.gutterUnit }}
          >
            Round will Close:{'\n'}
            <Text size='l' darkgrey={!isBlack} white={isBlack}>
              {this.state.time}
            </Text>
          </Text>
        ) : (
          <Text
            size={this.state.displayType === 'H' ? 'xxl' : 'huge'} darkgrey={!isBlack} white={isBlack}
            overrides={{ marginLeft: 0.5 * theme.gutterUnit }}
          >
            {this.state.time}
          </Text>
        )}
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  finishTime: state.game.finishTime
})

export default connect(mapStateToProps, {})(Clock)
